<template>
    <div v-if="!finished">
        <Question :question="currentQuestion" :number="position+1" @advance="advance" :user="user" />
        <div class="content content--full-mobile">
            <Progress ref="progress" :current="position + 1" :total="total" :user="user" />
        </div>
    </div>
    <ScoreShare v-else v-once :user="user" :quiz-type="type" @reset="resetQuiz" />
</template>

<script>
import Progress from "./Progress";
import Question from "./Question";
import User from "../Modules/User";
import ScoreShare from "./ScoreShare";
export default {
	name: "Quiz",
	components: {
		ScoreShare,
		Question,
		Progress,
		// Score
	},
	props: {
		questions: Array,
		user: User,
		type: {
			type: String,
			default: "kids"
		}
	},
	data: () => ({
		isLoading: false,
		position: 0,
	}),
	computed: {
		total() {
			return this.questions.length;
		},
		finished() {
			return this.position === this.total;
		},
		currentQuestion() {
			if (this.finished) {
				return null;
			}
			return this.questions[this.position];
		},
	},
	methods: {
		advance() {
			this.position += 1;
			window.emitter.emit("markAdvanced", this.position);
		},
		resetQuiz() {
			setTimeout(() => this.position = 0, 1500);
			window.emitter.emit("reset", this.position);
		}
	},
	created() {
		if (this.user.hasAnswers) {
			this.position = this.user.answers.length;
		}
		window.emitter.on("forceReset", this.resetQuiz);
	}
};
</script>
